import { Component, effect, inject, signal, viewChild, WritableSignal } from '@angular/core';
import {
  artworkFilters,
  FilterComponent,
  LikeButtonComponent,
} from "@components";
import { rxResource } from "@angular/core/rxjs-interop";
import { UserService } from "@api-services";
import { NgOptimizedImage } from "@angular/common";
import { IconDirective, IconMapPinLightComponent } from "@icons";
import { Router, RouterLink } from "@angular/router";
import { UserDto } from "@api-contracts";
import { map, tap } from "rxjs/operators";
import { debouncedSignal } from "../../../utils";

@Component({
  selector: 'wun-artists',
  imports: [
    FilterComponent,
    NgOptimizedImage,
    RouterLink,
    IconMapPinLightComponent,
    IconDirective,
    LikeButtonComponent
  ],
  templateUrl: './artists.component.html',
  styleUrl: './artists.component.scss'
})
export class ArtistsComponent {
  isGallery(): boolean {
    return this.router.url.includes('galleries');
  }

  private readonly artistsService = inject(UserService)
  private readonly router = inject(Router);
  filter = viewChild(FilterComponent);
  filterSignal: WritableSignal<artworkFilters | undefined> = signal({
    price: {
      from: 0,
      to: 100000
    },
    categories: [],
    subCategories: [],
    name: '',
    type: undefined,
    tags: []
  });

  filterDebounce = debouncedSignal(this.filterSignal, 400)

  _artists = rxResource({
    params: this.filterDebounce,
    stream: params => this.search(params.params)
  })

  artists = signal<UserDto[]>([])

  init: boolean = true;
  private debounceTime: number | undefined;

  constructor() {
    effect(() => {
      const filter = this.filter();
      if (filter) this.setFilters(filter.filter())
    });
  }

  setFilters(filters: artworkFilters) {
    clearTimeout(this.debounceTime)
    this.debounceTime = setTimeout(() => {
      if (!this.init)
        this.filterSignal.set(filters);
      else
        this.init = false;
    }, 300) as any;
  }

  search(request = this.filterSignal()) {
    const filters: Record<string, any> = {

    };
    if (request?.name) {
      filters['firstName'] = { $ilike: `%${request?.name}%` };
      filters['lastName'] = { $ilike: `%${request?.name}%` };
      filters['city'] = { $ilike: `%${request?.name}%` };
      filters['country'] = { $ilike: `%${request?.name}%` };
    }


    const fn = this.router.url.includes('galleries') ? this.artistsService.usersGetArtists : this.artistsService.usersGetGalleries;
    const args = {
      includes: JSON.stringify(['cover', 'covers']),
      pageSize: 1000,
      sorting: JSON.stringify(
        request?.sortBy === 'mostLiked' ? {likeCount: 'DESC'} :
        request?.sortBy === 'recent' ? {createdAt: 'DESC'} :
        {score: 'DESC'}
      ),
      filters: JSON.stringify({
        $and: [{ status: 'ACTIVE' }],
        $or: Object.entries(filters).reduce(
          (curr, item) => {
            curr.push({
              [item[0]]: item[1]
            })
            return curr;
          }, [] as Array<any>
        )
      })
    }
    const req = this.router.url.includes('galleries') ? this.artistsService.usersGetGalleries(args) : this.artistsService.usersGetArtists(args);
    return req.pipe(
      map(d => {
        return {
          hasNext: d.hasNext,
          hasPrevious: d.hasPrevious,
          data: d.data.map(d => {
            return {
              ...d,
              cover: d.covers.find(cover => cover.ref === d.cover!.ref)
            } as UserDto
          }).filter(ar => {
            if (request?.tags?.length)
              return request?.tags?.find(f => ar.topics.includes(f));
            return true;
          }),
          totalCount: d.totalCount,
        }
      }),
      tap(d => {
        this.artists.set(d.data || []);
      })
    )
  }
}
